export default {
	FOLDER: 'folder',
	LESSON: 'lesson',
	HOMEWORK_SHARED_PRESENTATION: 'homework_shared',
	BUNDLE: 'bundle',
	AUTHOR: 'author',
}
